export default {
  ptsi: {
    settings: "Settings",
    overdueTimeForDdsReport: "Overdue Time for DDS Report",
    setDefaultDueDateForDdsReport: "Set default due date for DDS report.",
    approvalExpirationPeriod: "Approval Expiration Period",
    setTheDefaultExpirationPeriodForDdsReportApprovals:
      "Set the default expiration period for DDS report approvals",
    visibilityOfDocument: "Visibility of Document",
    setDefaultSelectionForVisibilityOfDocumentsAttachedOnReport:
      "Set default selection for visibility of documents attached on report.",
    private: "Private (PTSI Administration Only)",
    privateNaccu: "Private (NACCU Administration Only)",
    visibleOnlyToAdminsHiddenFromAllCooperativesAndUsers:
      "Visible only to admins; hidden from all cooperatives and users.",
    cooperativeAndPtsiOnly: "Cooperative & PTSI Only",
    cooperativeAndNaccuOnly: "Cooperative & NACCU Only",
    visibleOnlyToTheAssignedCooperativeAndPlatformAdministrators:
      "Visible only to the assigned cooperative and platform administrators.",
    public: "Public",
    visibleToEveryoneIncludingAllUsersAndTheGeneralPublic:
      "Visible to everyone, including all users and the general public.",
    saveSettings: "Save Settings",
  },
};
